module.exports = __webpack_public_path__ + "img/appstore_url.7dab042c.png";